import type { NoticeWithType } from "../../components/ViewNotices";
import { noticeHref } from "../../routes";

/** What another page hands a Notice's page in router state: whether to open Send reminder ready. */
export type NoticeHandover = { openReminder?: boolean };

/** A Notice page's router state, read on arrival; anything else is no handover. */
export const readNoticeHandover = (state: unknown): NoticeHandover => {
  const { openReminder } = (state ?? {}) as NoticeHandover;
  return openReminder === true ? { openReminder: true } : {};
};

export const toNotice = (notice: NoticeWithType, handover: NoticeHandover = {}) => ({
  pathname: noticeHref(notice.noticeId),
  state: { notice, ...handover },
});

/**
 * The Notice a Notice page shows: the fresh copy once Notices are loaded,
 * otherwise the one handed over. Opened from just its address (a new tab,
 * as Nova's "Open original" does), it waits for Notices to load.
 */
export function noticeToShow<T extends { noticeId?: string }>(
  handedOver: T | undefined,
  idFromAddress: string | undefined,
  loaded: T[] | null | undefined,
): T | undefined | "loading" {
  const noticeId = handedOver?.noticeId ?? idFromAddress;
  if (!noticeId) return handedOver;
  if (!loaded) return handedOver ?? "loading";
  return loaded.find((notice) => notice.noticeId === noticeId) ?? handedOver;
}
